<template>
  <div class="page-deliver-todo">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">報表統計</div>
      <div class="breadcrumb-item">未上架報表</div>
    </div>
    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select
            style="width:100%;"
            size="small"
            placeholder="提貨櫃點"
            v-model="form.arrive"
            :clearable="true"
          >
            <Option
              :value="item.ReceivingID"
              v-for="(item, index) in pickAddress"
              :key="item.ReceivingID"
              >({{ item.cainiao_match }}) {{ item.ReceivingName }}
            </Option>
          </Select>
        </FormItem>

        <!--<FormItem>
          <Select
            style="width:100%;"
            size="small"
            placeholder="公司名稱"
            v-model="form.order_parent"
          >
            <Option
              :value="item.id"
              v-for="(item, index) in samcityType"
              :key="item.id"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>-->

        <FormItem>
          <Input
            size="small"
            placeholder="快遞單號"
            clearable
            v-model="form.odd_numbers"
            @keyup.enter.native="handleSearch()"
          ></Input>
        </FormItem>

        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="true"
            placeholder="開始時間"
            v-model="form.start_time"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="true"
            style="width: 100%;"
          ></DatePicker>
        </FormItem>

        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            :clearable="true"
            placeholder="結束時間"
            v-model="form.end_time"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="true"
            style="width: 100%;"
          ></DatePicker>
        </FormItem>

        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch">搜索</div>
            <div class="pg-btn style2" @click="$router.back()">返回</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <!--  <Spin fix class="pg-sub-loading" v-if="isSubmiting">
              <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
              <div class="loading-text">Loading</div>
          </Spin> -->

      <Table
        size="small"
        border
        :loading="isSubmiting"
        no-data-text="暫無數據"
        :columns="table.column"
        :data="table.data"
      >
        <template slot-scope="{ row, index }" slot="odd_numbers">
          <div class="avatar-box">
            <a class="pg-btn" @click="handleViewOrder(index)">{{
              row.odd_numbers
            }}</a>
          </div>
        </template>
      </Table>

      <div class="pg-pagger">
        <Row>
          <Col span="11" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="13" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>

    <Modal
      v-model="isShowModalSign_goods"
      title="查詢快件"
      width="1300"
      :footer-hide="true"
      @on-cancel="handleModalSignClose_goods"
    >
      <div class="modal-cont">
        <Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
          <Icon
            type="ios-loading"
            :size="20"
            class="demo-spin-icon-load"
          ></Icon>
          <div class="loading-text">Loading</div>
        </Spin>

        <div style="font-weight:bold">快遞信息</div>
        <br />
        <Table
          no-data-text=""
          :columns="table1.column"
          :data="table1.data"
        ></Table>
        <Table
          no-data-text=""
          :columns="table1.column1"
          :data="table1.data1"
        ></Table>
        <Table
          no-data-text=""
          :columns="table1.column2"
          :data="table1.data2"
        ></Table>
        <Table no-data-text="" :columns="table1.column3" :data="table1.data3">
          <template slot-scope="{ row, index }" slot="status">
            <span v-if="row.status == 0">珠海倉庫-待出庫</span>
            <span v-else-if="row.status == 1">珠海倉庫-已出庫</span>
            <span v-else-if="row.status == 2">澳門倉庫-配送中</span>
            <span v-else-if="row.status == 3">澳門門店/智能櫃-未簽收</span>
            <span v-else-if="row.status == 4">澳門門店/智能櫃-已簽收</span>
          </template>
        </Table>
        <Table
          no-data-text=""
          :columns="table1.column4"
          :data="table1.data4"
        ></Table>
        <Table
          no-data-text=""
          :columns="table1.column5"
          :data="table1.data5"
        ></Table>
        <br /><br />
        <div style="font-weight:bold">物流信息</div>
        <br />
        <div class="step-wrap" v-if="detail && detail.length">
          <div
            class="step-item clearfix"
            v-for="(item, index) in detail"
            :key="item.id"
          >
            <div class="left">
              <div class="l-date">
                <span>{{ item.date }}</span>
                <span>{{ item.week }}</span>
              </div>
              <div class="l-time">{{ item.time }}</div>
            </div>
            <div class="right">
              <div class="r-address">
                {{ item.describe }} , 操作人：{{ item.userinfos }}
              </div>
            </div>
          </div>
        </div>

        <div class="data-null" v-else>
          <div>暫無數據</div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from "dayjs";

export default {
  data() {
    return {
      detail: [],
      isShowModalSign_goods: false,
      isSubmitingLog: false,
      pageIndex: 1,
      curPageSize: 10,
      totalCount: 1,
      pageInput: '',
      form: {
        start_time: '',
        end_time: '',
        arrive: '',
        odd_numbers: '',
        order_parent: '',
      },
      isSubmiting: false,
      pickAddress: [],
      samcityType: [], //同城
      table: {
        column: [
          {
            title: '珠海出庫日期',
            key: 'out_time',
            align: 'center',
            sortable: true,
            minWidth: 100,
            className: 'demo-table-info-column',
          },
          /*{
            title: '公司名稱',
            key: 'order_parent_name',
            align: 'center',
            sortable: true,
            minWidth: 150,
            className: 'demo-table-info-column',
          },*/
          {
            title: '快遞單號',
            key: 'odd_numbers',
            slot: 'odd_numbers',
            align: 'center',
            sortable: true,
            minWidth: 150,
            className: 'demo-table-info-column',
          },
          {
            title: '門店/智能櫃',
            key: 'ReceivingName',
            align: 'center',
            sortable: true,
            minWidth: 100,
            className: 'demo-table-info-column',
          },
          {
            title: '未上架(日:時間)',
            key: 'on_shelf_days',
            align: 'center',
            sortable: true,
            minWidth: 100,
            className: 'demo-table-info-column',
          },
          {
            title: '備註說明',
            key: 'remarks',
            align: 'center',
            sortable: true,
            minWidth: 100,
            className: 'demo-table-info-column',
          },
        ],
        data: [],
      },
      table1: {
        column: [
          {
            title: '快遞單號',
            key: 'order',
            align: 'center',
            minWidth: 80,
          },
          {
            title: '客戶電話',
            key: 'phone',
            align: 'center',
            minWidth: 80,
          },
          {
            title: '客戶名稱',
            key: 'username',
            align: 'center',
            minWidth: 80,
          },
        ],
        column1: [
          {
            title: '重量',
            key: 'weight',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '尺寸',
            key: 'size_sum',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '提貨櫃點',
            key: 'store',
            align: 'center',
            minWidth: 100,
          },
        ],
        column2: [
          {
            title: '快件明細',
            key: 'detailed',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '異常件',
            key: 'abnormal',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '出庫袋號',
            key: 'sack_number',
            align: 'center',
            minWidth: 100,
          },
        ],
        column3: [
          {
            title: '最新貨態',
            slot: 'status',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '更新時間',
            key: 'created_time',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '貨架號',
            key: 'shelves',
            align: 'center',
            minWidth: 100,
          },
        ],
        column4: [
          {
            title: '代收費',
            key: 'amount',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '附加費',
            key: 'surcharge_price',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '到附運費',
            key: 'freight_collect',
            align: 'center',
            minWidth: 100,
          },
        ],
        column5: [
          {
            title: '超期費',
            key: 'outTime_price',
            align: 'center',
            minWidth: 100,
          },
          {
            title: '合計費用',
            key: 'total_price',
            align: 'center',
            minWidth: 100,
          },
        ],
        data: [],
        data1: [],
        data2: [],
        data3: [],
        data4: [],
        data5: [],
      },
    }
  },
  created() {
    this.form.arrive = this.$route.query.arrive
    this.getPickAddress()
    this.getSamcityList()
  },
  methods: {
    getSamcityList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.samecityUserList,
          method: 'get',
        })
        .then((res) => {
          if (res.code == 0) {
            this.samcityType = res.data.data
            this.getList()
          }
        })
    },
    handleViewOrder(index) {
      this.isShowModalSign_goods = true
      this.isSubmitingLog = true
      let tableData = this.table.data
	    this.table1.data = []
	    this.table1.data1 = []
	    this.table1.data2 = []
	    this.table1.data3 = []
	    this.table1.data4 = []
	    this.table1.data5 = []
      this.$Rq
        .requestAuth({
          url: this.$Api.all_search,
          method: 'get',
          data: {
            order: tableData[index].odd_numbers,
          },
        })
        .then((res) => {
          this.isSubmitingLog = false
          let tempArr = []
          let tempArr1 = []
          let tempArr2 = []
          let tempArr3 = []
          let tempArr4 = []
          let tempArr5 = []
          let resData = res.data

          if (res.code == 0) {
            for (let i = 0; i < resData.data.length; i++) {
              tempArr.push({
                order: resData.data[i].order,
                username: resData.data[i].username,
                phone: resData.data[i].phone,
              })

              tempArr1.push({
                weight: resData.data[i].weight,
                size_sum:
                  resData.data[i].long +
                  'x' +
                  resData.data[i].width +
                  'x' +
                  resData.data[i].height,
                store:
                  resData.data[i].store == null
                    ? '- - -'
                    : resData.data[i].store.ReceivingName,
              })

              tempArr2.push({
                sack_number: resData.data[i].sack_number,
                detailed:
                  resData.data[i].detailed == null
                    ? '- - -'
                    : resData.data[i].detailed.name,
                abnormal: resData.data[i].abnormal == 0 ? '否' : '是',
              })

              tempArr3.push({
                shelves:
                  resData.data[i].shelves == null
                    ? '- - -'
                    : resData.data[i].shelves.code,
                status: resData.data[i].status,
                created_time: resData.data[i].created_time,
              })

              tempArr4.push({
                amount: resData.data[i].amount,
                surcharge_price: resData.data[i].surcharge_price,
                freight_collect: resData.data[i].freight_collect,
              })

              tempArr5.push({
                outTime_price: resData.data[i].outTime_price,
                total_price:
                  Number(resData.data[i].surcharge_price) +
                  Number(resData.data[i].outTime_price) +
                  Number(resData.data[i].freight_collect) +
                  Number(resData.data[i].amount),
              })
            }
            this.table1.data = tempArr
            this.table1.data1 = tempArr1
            this.table1.data2 = tempArr2
            this.table1.data3 = tempArr3
            this.table1.data4 = tempArr4
            this.table1.data5 = tempArr5
          }
        })
        .catch((err) => {
          this.isSubmitingLog = false
        })

      this.isSubmitingLog = true
      this.$Rq
        .requestAuth({
          url: this.$Api.logisticsInfo + '/' + tableData[index].odd_numbers,
          method: 'get',
          data: {},
        })
        .then((res) => {
          this.isSubmitingLog = false
          if (Number(res.code) == 0) {
            let resData = res.data
            let tempArr = []
            let userinfo

            for (let j = 0; j < resData.length; j++) {
              let datetime = this.getDateTime(resData[j].created_at)

              if (resData[j].userinfos == null) {
                if (resData[j].remarks.match(/[\u606d\u559c\u60a8]/g)) {
                  userinfo = '用戶線上支付'
                } else {
                  if (resData[i].admin_name != null) {
                    userinfo = resData[i].admin_name
                  } else {
                    userinfo = '智能櫃派送員'
                  }
                }
              } else {
                userinfo = resData[j].userinfos.username
              }

              tempArr.push({
                userinfos: userinfo,
                id: resData[j].id,
                date: datetime.date,
                week: datetime.week,
                time: datetime.time,
                describe: resData[j].remarks,
              })
            }

            this.detail = tempArr
          }
        })
        .catch((err) => {
          this.isSubmitingLog = false
        })
    },
    homeDetail(index) {
      let tableData = this.table.data
      this.$router.push({
        path: '/homeDetail?order=' + tableData[index].odd_numbers,
      })
    },
    formatDate(datetime) {
      if (!datetime) return ''

      let dateTime = new Date(datetime)
      let year = dateTime.getFullYear()
      let month = dateTime.getMonth() + 1
      let date = dateTime.getDate()
      let hour = dateTime.getHours()
      let minute = dateTime.getMinutes()
      let second = dateTime.getSeconds()
      let milliseconds = dateTime.getMilliseconds()
      return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(
        date
      )} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(
        milliseconds
      )}`
    },
    formatNum(num) {
      return num < 10 ? '0' + num : num
    },
    getDateTime(datetime) {
      let date = new Date(datetime)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()
      let week = date.getDay()
      let weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

      return {
        date: `${this.formateNum_log(year)}-${this.formateNum_log(
          month
        )}-${this.formateNum_log(day)}`,
        time: `${this.formateNum_log(hour)}:${this.formateNum_log(
          minute
        )}:${this.formateNum_log(second)}`,
        week: weekList[week],
      }
    },
    formateNum_log(num) {
      return num > 9 ? num : '0' + num
    },
    handleModalSignClose_goods() {
      this.isShowModalSign_goods = false
    },
    //提貨櫃點
    getPickAddress() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: 'get',
          data: {
            company_id: 0,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(it=>it.company_id != 15)
            if (res.data.data.length <= 1) {
              this.form.arrive = res.data.data[0].ReceivingID
            }
          }
        })
    },
    getList() {
      let form = this.form
      this.isSubmiting = true
      this.$Rq
        .requestAuth({
          url: this.$Api.zhoutList,
          method: 'get',
          data: {
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            start_time: this.formatDate(form.start_time),
            end_time: this.formatDate(form.end_time),
            admin_id: '',
            odd_numbers: form.odd_numbers,
            order_parent: form.order_parent || '',
	          status: 1,  //0待出库, 1已出库
	          arrive: form.arrive,
	          arrive_type: '',
	          goods_type: 0,
	          recipient_contacts: '',
	          phone: '',
	          sack_number: '',
          },
        })
        .then((res) => {
          this.isSubmiting = false
          if (res.code == 0) {
            let tempArr = []
            let resData = res.data.data

            for (let i = 0; i < resData.length; i++) {
	            const givenTime = resData[i].out_time || dayjs();
	            // 当前时间
	            const now = dayjs();
	
	            // 计算时间差
	            const diff = dayjs(givenTime).diff(now);
	            // 将差值转换为天和小时
	            // 计算绝对值
	            const absDiff = Math.abs(diff);
	
	            // 将差值转换为天和小时
	            const days = Math.floor(absDiff / (1000 * 60 * 60 * 24)); // 计算天数
	            const hours = Math.floor((absDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // 计算小时
              tempArr.push({
                remarks:
                  resData[i].remarks == null ? '- - -' : resData[i].remarks,
                order_parent_name:
                  resData[i].order_parent_name == null
                    ? '---'
                    : resData[i].order_parent_name,
                out_time: resData[i].out_time,
                odd_numbers: resData[i].odd_numbers,
                ReceivingName: resData[i].store.ReceivingName,
                on_shelf_days:`${days}天${hours}小時`,
              })
            }

            this.totalCount = res.data.count
            this.table.data = tempArr
          }
        })
        .catch((err) => {
          // this.isLoading = false;
          this.isSubmiting = false
        })
    },

    handleSearch() {
      // if (this.form.start_time === '') {
      //     this.$Utils.showTipInfo('請輸入起始時間');
      //     return;
      // }
      this.pageIndex = 1
      this.getList()
    },

    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1
      this.getList()
    },

    handlePageInput() {
      let value = ('' + this.pageInput).replace(/\D/g, '')
      let pageCount = Math.ceil(this.totalCount / this.curPageSize)
      if (value > pageCount) {
        value = pageCount
      }
      this.pageInput = value
    },
    handlePageEnter() {
      if (this.pageInput == '' || this.pageInput == this.pageIndex) return
      if (this.pageInput == 0) {
        this.pageInput = 1
      }
      this.pageInput = parseInt(this.pageInput)
      this.pageIndex = this.pageInput
      this.getList()
    },

    handlePageChange(value) {
      this.pageIndex = value
      this.getList()
    },
  },
}
</script>

<style>
.ivu-table td.demo-table-info-column {
  background-color: #ffebde;
  color: #000;
}
</style>

<style lang="scss" scoped>
@import 'notOnshelf.scss';
</style>
